export default __webpack_public_path__ + "287c5f2086c67ad74d3572c7cb057707.svg";